import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludesSection } from '../components/IncludesSection';
import { ProcessSection } from '../components/ProcessSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-stone-50 font-sans selection:bg-emerald-200 selection:text-emerald-900" data-id="element-314">
      <Hero data-id="element-315" />
      <ProblemSection data-id="element-316" />
      <SolutionSection data-id="element-317" />
      <IncludesSection data-id="element-318" />
      <ProcessSection data-id="element-319" />
      <FAQSection data-id="element-320" />
      <CTASection data-id="element-321" />
      <Footer data-id="element-322" />
    </main>;
}